import { render, staticRenderFns } from "./task-set-supervision-manager.vue?vue&type=template&id=4cf2246e&scoped=true&"
import script from "./task-set-supervision-manager.vue?vue&type=script&lang=js&"
export * from "./task-set-supervision-manager.vue?vue&type=script&lang=js&"
import style0 from "./task-set-supervision-manager.vue?vue&type=style&index=0&id=4cf2246e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2246e",
  null
  
)

export default component.exports